import { CalendarDays, ExternalLink } from "lucide-react";

const Workshops = () => {
  const dates = ["Jan 24–25", "Feb 6–7", "Feb 21–22", "Mar 7–8"];

  return (
    <section
      name="workshops"
      className="py-6 lg:py-12 bg-light-gray font-montserrat flex flex-col items-center px-6"
    >
      {/* Heading */}
      <h1 className="text-black font-bold text-2xl lg:text-3xl tracking-wide text-center">
        The Strategic Macro Social Work Pivot
      </h1>

      {/* Subheading Text */}
      <p className="text-dark-gray text-sm lg:text-base text-center max-w-3xl mt-2  lg:mt-4 leading-relaxed">
        A 2-day virtual guided workshop supporting identity exploration and early
        professional development for social work students and emerging practitioners.
      </p>

      {/* Registration Box */}
      <div className="bg-white shadow-xs lg:shadow-md rounded-3xl p-8 lg:p-10  mt-4 lg:mt-6 max-w-2xl w-full text-center border border-soft-gold/40">
        <h2 className="text-black font-semibold text-xl lg:text-2xl mb-2 lg:mb-4">
          Register for the Workshop
        </h2>

        <p className="text-gray-700 text-sm mb-4 lg:mb-6 leading-relaxed">
          Complete a brief survey — it will forward you to Eventbrite to purchase your
          workshop ticket <strong>($35 + tax)</strong>.
        </p>

        <a
          href="https://usc.qualtrics.com/jfe/form/SV_b25ngPGY4L5PSR0"
          target="_blank"
          className="inline-flex items-center gap-2 bg-soft-gold text-black font-semibold py-3 px-8 rounded-2xl transition-all shadow-sm hover:shadow-xl"
        >
          Register Here
          <ExternalLink className="w-5 h-5" />
        </a>
      </div>

      {/* Workshops Dates Section */}
      <h2 className="text-black font-semibold text-xl lg:text-3xl text-center mt-6 lg:mt-8 mb-5 lg:mb-10">
        Upcoming Workshop Dates
      </h2>

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 lg:gap-8 w-full max-w-6xl">
        {dates.map((date, index) => (
          <div
            key={index}
            className="rounded-3xl bg-soft-gold shadow-sm lg:shadow-xl p-3 lg:p-6 flex flex-col items-center justify-center gap-3 text-center
             transition-transform duration-300"
          >
            <CalendarDays className="w-10 h-10 text-black animate-bounce-slow" />
            <div className="text-sm lg:text-xl font-bold text-black">
              {date}
            </div>
            <div className="text-xs lg:text-base text-dark-gray">1 PM – 4 PM CST</div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Workshops;
